import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline';
  fullWidth?: boolean;
  children: React.ReactNode;
  icon?: boolean;
  href?: string;
}
export function Button({
  variant = 'primary',
  fullWidth = false,
  children,
  icon = true,
  className = '',
  href,
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center px-8 py-4 text-lg font-semibold rounded-lg transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-midnight-900 disabled:opacity-50 disabled:cursor-not-allowed';
  const variants = {
    primary: 'bg-[#2D7DFF] text-white hover:bg-[#1E63D8] shadow-[0_10px_30px_rgba(45,125,255,0.18)]',
    secondary: 'bg-[rgba(255,255,255,0.03)] text-white border border-[rgba(255,255,255,0.08)] hover:bg-[rgba(255,255,255,0.08)]',
    outline: 'bg-transparent border-2 border-[#2D7DFF] text-[#2D7DFF] hover:bg-[#2D7DFF]/10'
  };
  const combinedClassName = `${baseStyles} ${variants[variant]} ${fullWidth ? 'w-full' : ''} ${className}`;
  if (href) {
    return <motion.a href={href} target="_blank" rel="noopener noreferrer" whileTap={{
      scale: 0.98
    }} className={combinedClassName} data-id="element-175">
        {children}
        {icon && <ArrowRight className="ml-2 h-5 w-5" data-id="element-176" />}
      </motion.a>;
  }
  return <motion.button whileTap={{
    scale: 0.98
  }} className={combinedClassName} {...props} data-id="element-177">
      {children}
      {icon && <ArrowRight className="ml-2 h-5 w-5" data-id="element-178" />}
    </motion.button>;
}